import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getProducts = async () => {
  const response = await axios.get(`${base_url}product/all`, getAuthHeaders());

  return response.data;
};

const createProduct = async (productData) => {
  const token = getToken();
  const response = await axios.post(`${base_url}product/add`, productData, {
    headers: {
      Authorization: `Bearer ${token}`,
      // Do not set Content-Type: multipart/form-data manually — the browser
      // must add the boundary parameter or the server will not parse files.
    },
  });

  return response.data;
};

const getProduct = async (id) => {
  const response = await axios.get(`${base_url}product/show/${id}`, getAuthHeaders());
  return response.data;
};

const deleteProduct = async (id) => {
  const response = await axios.delete(`${base_url}product/delete/${id}`, getAuthHeaders());

  return response.data;
};

const updateProduct = async (id, productData) => {
  const token = getToken();
  const response = await axios.put(`${base_url}product/edit/${id}`, productData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

const productService = {
  getProducts,
  createProduct,
  getProduct,
  deleteProduct,
  updateProduct
};

export default productService;
